module.exports = "/images/vendor/flag-icon-css/flags/4x3/np.svg?b66578a5c732da35e2c8af86e46ff93b";